import React from 'react';

const PageHeader = ({ title, description, actions, badge }) => (
  <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
    <div>
      <div className="flex flex-wrap items-center gap-3">
        <h1 className="text-2xl font-bold tracking-tight text-white sm:text-3xl">{title}</h1>
        {badge}
      </div>
      {description && (
        <div className="mt-2 flex max-w-3xl flex-wrap items-center gap-x-2 gap-y-1 text-sm text-slate-300 sm:text-base">
          {description}
        </div>
      )}
    </div>
    {actions && <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>}
  </div>
);

export default PageHeader;
